import {Component, OnInit} from '@angular/core';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ShipmentDriversService} from "../services/shipment-drivers.service";

@Component({
    selector: 'app-driver-status-modal',
    templateUrl: './driver-status-modal.component.html',
    styleUrls: ['./driver-status-modal.component.scss'],
    providers: [ShipmentDriversService]
})
export class DriverStatusModalComponent implements OnInit {

    modal: NgbModalRef;
    driverId: string;
    driver: any;
    route: any;
    public shipments: any[];
    public grouped: any;

    constructor(public shipmentDriversService: ShipmentDriversService) {
    }

    ngOnInit(): void {

        this.shipmentDriversService.getShipmentDriverStatus(this.driverId).then(((data: any) => {
            this.shipments = data.data;
            this.driver = data.driver;
            this.route = data.route;
            this.grouped = this.shipments.reduce((acc, curr) => {
                if (curr.status_ordering >= 100) {
                    if (!acc['Completed']) {
                        acc['Completed'] = [];
                    }
                    acc['Completed'].push(curr);
                } else {
                    if (!acc['Pending']) {
                        acc['Pending'] = [];
                    }
                    acc['Pending'].push(curr);
                }

                return acc;
            }, {});
        }));
    }

    close() {
        this.modal.close();
    }

}
